import {Init} from "core/Init";


class Elevation {

    protected _listeners: Array<any> = [];

    constructor() {

    }



    destroy() {

        for (let i of this._listeners) {

            Init.emitter.off(i[0], i[1]);
        }
    }
}

export {Elevation};
